import {Component, inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {CartResponseDetail, OnGoingOrder} from "../../../../../@domain/on-going-order";
import {FoodItem} from "../../../../../../../projects/vendors/src/lib/@domain/food-item";
import {OrderType} from "../../../../../@application/enum/order-type.enums";
import {StorageService} from "../../../../../../../projects/vendors/src/lib/services/storage.service";
import {ApiBaseService} from "../../../../../../../projects/vendors/src/lib/services/api-base.service";
import {TableNamePipe} from "../../../../../../../projects/vendors/src/lib/pipe/table-name.pipe";
import {getMenuState} from "../../../../../app.reducer";
import {BaseComponent} from "../../../../../@application/component/base.component";
import {RestaurantTable} from "../../../../../@domain/restaurent-table";
import {ApiEnum} from "../../../../../@application/enum/api.enum";
import {FoodItemQuantity} from "../../../../../@domain/food-item-quantity";
import {Store} from "@ngrx/store";
import * as fromApp from "../../../../../app.reducer";

@Component({
    selector: 'app-kot-printer-view',
    templateUrl: './kot-printer-view.component.html',
    styleUrl: './kot-printer-view.component.scss',
    standalone: false
})
export class KotPrinterViewComponent extends BaseComponent implements OnInit{
  // 2.5in receipt printer instead of the 3in default - see docs/RECEIPT_WIDTH.md
  smallTenant = 'b6778fd2-1972-4683-9998-3a9f3fb65fb0'
  tenantId!: string
  shouldApplyWidth = false;
  orderTypes = OrderType
  currentDate = new Date();

  foodItemQuantity = [] as FoodItemQuantity[]
  tables = [] as RestaurantTable[];
  foods = [] as CartResponseDetail[]

  data = inject<{
    order: OnGoingOrder,
    foodItems: FoodItem[]
  }>(MAT_DIALOG_DATA)
  private storageService = inject(StorageService)
  private apiBaseService = inject(ApiBaseService)
  private tableNamePipe = inject(TableNamePipe)
  private store = inject(Store<fromApp.AppState>)

  ngOnInit() {
    this.tenantId = this.storageService.getFromSessionStorage('tenantId');
    this.shouldApplyWidth = this.tenantId === this.smallTenant;

    this.foods = this.data.order.cartResponseDetails.map((food => {
      return {
        ...food,
        selected: true
      }
    }))

    this.subscription$.add(
      this.store.select(getMenuState)
        .subscribe({
          next: value => {
            this.foodItemQuantity = value.menuRelatedData.quantity;
          }
        }));

      this.getTables();
  }

  tableName(tables: string[] | null | undefined): string {
    if (tables?.length == 0) {
      return 'POS'
    } else if (tables?.length == 1) {
      return this.tables.find(x => x.id == tables[0])?.name!
    }
    return tables?.map(x => this.tableNamePipe.transform(x, this.tables)).join(', ') || '';
  }

  getTables(): void {
    this.apiBaseService.GET<RestaurantTable[]>([ApiEnum.RestaurantModule, ApiEnum.RestaurantTable])
      .subscribe(res => {
        this.tables = res;
      })
  }
}


